<template>
    <div>
        <v-dialog v-model="dialogoEditar" max-width="800px" persistent>
            <v-card>
                <v-overlay :value="isLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-card-title class="tituloPopUp justify-center">Editar Dados</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="permissoes-inline">
                                    <div v-for="(permissao, index) in permissoesAll" :key="index"
                                        class="permissao-item">
                                        <span class="nivel">{{ permissao.nivel }}</span>
                                        <span class="descricao">- {{ permissao.descricao }}</span>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field label="Descrição" v-model="dados.descricao"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field disabled label="Autor da última actualização"
                                        v-model="dados.modifiedBy"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field disabled label="Data" v-model="dados.modifiedOn"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Permissões" :rules="[validateFormat]" @input="sanitizeInput"
                                        v-model="dados.niveis"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <div class="tpaCombox">
                                        <v-combobox v-model="statusSelected" label="Status" item-value="id"
                                            item-text="descricao" :items="statusOpcoes" return-object></v-combobox>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="hideCard(false)">Fechar</v-btn>
                    <v-btn color="green darken-1" :disabled="!valid" @click="Salvar()"
                        style="color: white">Atualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "@/plugins/axios";

export default {
    props: ["dados"],
    data: () => ({
        isLoading: false,
        dialogoEditar: true,
        valid: true,
        statusSelected: null,
        statusOpcoes: [
            { id: 1, descricao: 'Ativo' },
            { id: 0, descricao: 'Desativado' }
        ],
        permissoesAll: []
    }),

    computed: {
        usuario() {
            return require("local-storage").get('nomeUsuario');
        }
    },

    created() {
        this.statusSelected = this.statusOpcoes.find(s => s.id == this.dados.status) || null;
        this.carregarPermissoes();
    },

    methods: {
        async carregarPermissoes() {
            try {
                const response = await axios.get('/ObterPermissoesLista');
                this.permissoesAll = response.data || [];
            } catch {
                Swal.fire('Erro', 'Ocorreu um erro ao carregar as permissões!', 'error');
            }
        },

        validateFormat(value) {
            const regex = /^(\d+)(,\d+)*$/;
            return regex.test(value) || "Insira números separados por vírgulas corretamente.";
        },

        sanitizeInput() {
            this.dados.niveis = this.dados.niveis
                .replace(/[^0-9,]/g, "")
                .replace(/,{2,}/g, ",")
                .replace(/^,|,$/g, "");
        },

        hideCard(bool) {
            this.dialogoEditar = false;
            this.statusSelected = null;
            this.$emit("fecharCardEditar", bool);
        },

        async Salvar() {
            this.isLoading = true;
            try {
                const params = {
                    id: this.dados.id,
                    descricao: this.dados.descricao,
                    permissoes: this.dados.niveis,
                    status: this.statusSelected.id,
                    autor: this.usuario
                };

                const result = await axios.post('/updateFuncaoRole', params);

                if (result.status == 200 && result.data.affectedRows >= 1) {
                    Swal.fire('Sucesso', 'Dados atualizados com sucesso!', 'success');
                    this.hideCard(true);
                } else {
                    Swal.fire('Erro', 'Ocorreu um erro ao realizar a operação!', 'error');
                }
            } catch {
                Swal.fire('Erro', 'Ocorreu um erro ao realizar a operação!', 'error');
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style></style>
